import { Link } from "react-router-dom";
import styled from "styled-components";
import { Button, Header } from "./Styles";

const MissingWrapper = styled.div`
  display: flex;
  padding: 1rem;
`;

function Missing() {
  return (
    <MissingWrapper>
      <article style={{ padding: "100px" }}>
        <Header>Page Not Found</Header>
        {/* <HeaderTitle>Page Not Found</HeaderTitle> */}
        <Link to="/">
          <Button>Back to Homepage</Button>
        </Link>
      </article>
    </MissingWrapper>
  );
}

export default Missing;
